import React from 'react';
import View from './view';
import {ServicesItem} from './interface';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../redux/selectors/resources';
import {Screens} from '../../routing';
import {useNavigation} from '@react-navigation/native';
import {images} from '../../../assets/icons';
import {useDeviceSize, DeviceSize} from '../../theme/helpers';
import {holderProfileSelector} from '../../../redux/selectors/profile';
import {Content} from '../../models/content';
import {UscType} from '../../models/profile/uscType';
import {CardStatus} from '../../../types/enums/cardStatus';

const items: Omit<ServicesItem, 'body' | 'title'>[] = [
  {
    key: Screens.TransportService,
    icon: ({theme, ...props}) => (
      <images.Transport {...props} color={theme.supportService.iconsColor.transport} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery1 hideForVisuallyImpaired />,
  },
  {
    key: Screens.BankingService,
    icon: ({theme, ...props}) => (
      <images.Banking {...props} color={theme.supportService.iconsColor.banking} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery3 hideForVisuallyImpaired />,
  },
  {
    key: Screens.PrivilegesService,
    icon: ({theme, ...props}) => (
      <images.Privileges {...props} color={theme.supportService.iconsColor.privileges} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery2 hideForVisuallyImpaired />,
  },
  {
    key: Screens.LoyaltyProgram,
    icon: ({theme, ...props}) => (
      <images.Loyalty {...props} color={theme.supportService.iconsColor.loyalty} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery5 hideForVisuallyImpaired />,
  },
  {
    key: Screens.VolunteersService,
    icon: ({theme, ...props}) => (
      <images.Volunteering {...props} color={theme.supportService.iconsColor.volunteers} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery5 hideForVisuallyImpaired />,
  },
  {
    key: Screens.RewardShop,
    icon: ({theme, ...props}) => (
      <images.RewardShopIcon {...props} color={theme.supportService.iconsColor.rewardShop} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery5 hideForVisuallyImpaired />,
  },
  {
    key: Screens.Cashback,
    icon: ({theme, ...props}) => (
      <images.Cashback {...props} color={theme.color.cashbackIcon} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery5 hideForVisuallyImpaired />,
  },
  {
    key: Screens.ECertificates,
    icon: ({theme, ...props}) => (
      <images.ECertificates {...props} color={theme.supportService.iconsColor.certificates} hideForVisuallyImpaired />
    ),
    tracery: () => <images.Tracery5 hideForVisuallyImpaired />,
  },
];

interface Props {
  useBackgroundPattern?: boolean;
}

export const ServicesContent: React.FC<Props> = ({useBackgroundPattern}) => {
  const content = useSelector(contentSelector());
  const holderProfile = useSelector(holderProfileSelector());

  const deviceSize = useDeviceSize();
  const nav = useNavigation();

  const isFinancialCard = holderProfile?.uscType === UscType.Financial;

  let itemsForRender = items;
  if (!holderProfile) {
    itemsForRender = [];
  } else {
    const disabledItems: {[key in keyof Content['services']]?: boolean} = {};
    if (!isFinancialCard) {
      disabledItems[Screens.BankingService] = true;
    }
    if (holderProfile?.cardStatusId === CardStatus.Blocked) {
      disabledItems[Screens.TransportService] = true;
    }
    itemsForRender = items.filter((i) => !disabledItems[i.key]);
  }

  return React.createElement(View, {
    useBackgroundPattern,
    items: itemsForRender.map((i) => ({
      ...i,
      body: content.services[i.key].cardBody,
      title: content.services[i.key].cardTitle,
    })),
    onPress(item: ServicesItem) {
      deviceSize === DeviceSize.desktop
        ? nav.navigate(item.key)
        : nav.navigate(Screens.CardServicesMenu, {screen: item.key, initial: false});
    },
  });
};

export const ServicesContentSimple: React.FC = () => {
  const content = useSelector(contentSelector());

  return React.createElement(View, {
    items: items.map((i) => ({...i, body: content.services[i.key].cardBody, title: content.services[i.key].cardTitle})),
    onPress: () => {},
  });
};
